import { auth } from 'lib/auth';
import { useEffect, useMemo, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { userStore } from 'stores/userStore';

export function useLogin(v2?: boolean) {
	// login logic - is a hook possible here?
	const isLogin = useRecoilValue(userStore.loginSettings);
	const isLoggedIn = isLogin?.isCompleteLoginProcess || false;
	const isLoggedInV2 = auth.getUserId();
	const [openLoginDialog, setOpenLoginDialog] = useState(!isLoggedIn);

	const handleLoginDialogClose = () => {
		if (isLoggedIn) {
			setOpenLoginDialog(false);
		}
	};
	const handlePostSignup = (success: boolean) => {
		if (success) {
			setOpenLoginDialog(false);
		}
	};

	const isLoginDialogOpenAndUnauthenticated = useMemo(() => openLoginDialog && !isLoggedIn, [openLoginDialog, isLoggedIn]);

	useEffect(() => {
		if (v2) {
			setOpenLoginDialog(!isLoggedInV2);
		} else {
			setOpenLoginDialog(!isLoggedIn);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		isLoggedIn,
		isLoggedInV2,
		// isLogin?.isLogin,
		// openLoginDialog,	// why is this necessary?
		// setOpenLoginDialog, // why is this necessary?
	]);

	return {
		isLoggedIn,
		openLoginDialog,
		isLoginDialogOpenAndUnauthenticated,
		setOpenLoginDialog,
		isLoggedInV2,
		handlePostSignup,
		handleLoginDialogClose,
	};
}
